'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fi = {
  code: "fi",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "Edellinen",
    next: "Seuraava",
    today: "T\xE4n\xE4\xE4n",
    month: "Kuukausi",
    week: "Viikko",
    day: "P\xE4iv\xE4",
    list: "Tapahtumat"
  },
  weekText: "Vk",
  allDayText: "Koko p\xE4iv\xE4",
  moreLinkText: "lis\xE4\xE4",
  noEventsText: "Ei n\xE4ytett\xE4vi\xE4 tapahtumia"
};

exports.default = fi;
